<template>
    <select :name="name" :class="['form-control', className]" :multiple="multiple" />
</template>

<script>
export default {
    name: 'NewPaymentFormSelect',
    props: {
        name: '',
        placeholder:'',
        options: [ Object, Array ],
        value: null,
        multiple: {
            Boolean,
            default: false
        },
        valueType: '',
        className: '',
        minimumResultsForSearch: 0
    },
    data() {
        return {
            select2data: [],
            dataSearch: true
        }
    },
    mounted() {
        this.formatOptions();

        let vm = this;
        let select = $(this.$el);

        select.select2({
            placeholder: this.placeholder,
            width: '100%',
            dropdownParent: select.parent(),
            data: this.select2data,
            minimumResultsForSearch: this.minimumResultsForSearch
        })
            .on('change', function () {
                vm.$emit('input', select.val());
                vm.$emit('change', select.val());
            });

        this.value && select.val(this.value).trigger('change');
    },
    methods: {
        formatOptions() {
            this.select2data.push({
                id: '',
                text: this.placeholder
            });

            for (let key in this.options) {
                let id = '';
                let title = '';

                switch(this.valueType) {
                    case 'text':
                    case 'number':
                        id = this.options[key];
                        title = this.options[key];
                        break;
                    case 'object':
                        id = this.options[key].id;
                        title = this.options[key].title || this.options[key];
                        break;
                    default:
                        id = key;
                        title = this.options[key].title || this.options[key];
                        break;
                }
                this.select2data.push({
                    id: id,
                    text: title
                });
            }
        }
    },
    destroyed: function () {
        $(this.$el).off().select2('destroy')
    }
}
</script>

